import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { media } from '../styles/Mixin';

const Text = styled.span`
  ${media.deskTop`
    font-size:${(props) => props.theme.deskBigFontSize};
  `}
  ${media.mobile`
    font-size:${(props) => props.theme.mobileBigFontSize};
  `}
`;

const BigText = ({ text, className, onClick }) => (
    <Text className={className} onClick={onClick}>
        {text}
    </Text>
);

BigText.propTypes = {
    text: PropTypes.string.isRequired
};

export default BigText;
